(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["common-questions"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const faqsTitle = document.querySelectorAll('.faqs-title');

    faqsTitle.forEach((item) => {
      item.addEventListener('click', function () {
        item.parentNode.classList.toggle('faqs-item-active');
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["common-video"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    // 获取页面上所有的视频容器
    const videoContainers = document.querySelectorAll('.video-content');

    videoContainers.forEach(function(container) {
      const video = container.querySelector('video');
      const videoLayer = container.querySelector('.video-layer');

      // 点击遮罩层开始播放视频
      videoLayer.addEventListener('click', function() {
        video.play();
        video.setAttribute('controls', 'controls');
        this.style.display = 'none';
      });

      video.addEventListener('pause', function() {
        videoLayer.style.display = 'flex';
      });

      video.addEventListener('play', function() {
        if (! video.paused) {
          videoLayer.style.display = 'none';
        }
      });

      video.addEventListener('click', function(e) {
        e.stopPropagation();
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-down"] && !Shopify.designMode) return;
  try {
    
          document.addEventListener('DOMContentLoaded', function () {
            const title = document.querySelectorAll('.downloads-tabs-title');
            const tabs = document.querySelectorAll('.downloads-tabs-content');

            title.forEach((item, index) => {
                item.addEventListener('click', () => {
                    title.forEach(tab => tab.classList.remove('tabs-title-active'));
                    tabs.forEach(tab => tab.classList.remove('downloads-tabs-active'));

                    item.classList.add('tabs-title-active');
                    tabs[index].classList.add('downloads-tabs-active');
                });
            });
        });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article"]) return;
  try {
    
    document.addEventListener('DOMContentLoaded', function () {
            const headings = {};

            if (window.innerWidth < 769) {
                const mainArticlePage = document.querySelector('.t4s-main-article-page');
                const blogTag = document.querySelector('.cs-blog-tag');
                const authorAbout = document.querySelector('.cs_author_about');
                if (mainArticlePage && blogTag && authorAbout) {
                    mainArticlePage.insertBefore(blogTag, authorAbout);
                }
            }

            const generatedContent = document.querySelector('.cs-catalogue-con');
            const mainBlog = document.querySelector('.article-template__content');
            const mainBlogTitle = document.querySelectorAll('.article-template__content h2');
            let currentLevel = 1;
            let currentSubLevel = 1;

            mainBlogTitle.forEach(function (element, index) {
                const tagName = element.tagName.toLowerCase();
                const text = element.textContent;
                const slug = `leagend-${index}`;
                element.id = slug;

                if (tagName === 'h2') {
                    headings[text] = [];
                    currentSubLevel = 1;
                } else {
                    let parentHeadingText = "";
                    let prevElement = element.previousElementSibling;

                    while (prevElement) {
                        if (prevElement.tagName.toLowerCase() === 'h2') {
                            parentHeadingText = prevElement.textContent;
                            break;
                        }
                        prevElement = prevElement.previousElementSibling;
                    }

                    if (!parentHeadingText || !headings[parentHeadingText]) {
                        return;
                    }

                    headings[parentHeadingText].push(text);
                }
            });

            Object.entries(headings).forEach(([h2Text, h3Array], index) => {
                console.log(h2Text, h3Array, index);

                const slug = `leagend-${index}`;

                const catalogueCon = document.createElement('div');
                catalogueCon.className = 'cs-catalogue-con';

                const h2 = document.createElement('div');
                h2.className = 'h2';

                const h2Title = document.createElement('a');
                h2Title.href = `#${slug}`;
                h2Title.className = 'h2-title';
                h2Title.textContent = `${currentLevel}. ${h2Text}`;

                h2.appendChild(h2Title);

                const h2Con = document.createElement('div');
                h2Con.className = 'h2-con';

                h2.appendChild(h2Con);
                generatedContent.appendChild(h2);
                currentLevel++;
            });

            let linkTime = setTimeout(() => {
                document.querySelectorAll('a[href^="#"]').forEach(anchor => {
                    anchor.addEventListener('click', function (e) {
                        e.preventDefault();

                        const target = document.querySelector(this.getAttribute('href'));
                        if (target) {
                            const navHeight = 120;
                            const topPos = target.getBoundingClientRect().top + window.pageYOffset - navHeight;

                            window.scrollTo({
                                top: topPos,
                                behavior: 'smooth'
                            });
                        }
                    });
                });
                clearTimeout(linkTime);
            }, 1000);

            document.querySelectorAll('.cs-catalogue-title').forEach(title => {
                title.addEventListener('click', function () {
                    this.parentElement.classList.toggle('cs-catalogue-active');
                });
            });
        });
    

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-sell"] && !Shopify.designMode) return;
  try {
    
   document.addEventListener('DOMContentLoaded', function () {
    if (window.innerWidth < 768) {
      let patentsSwiper = new Swiper('.sell-swiper-list', {
        slidesPerView: 'auto',
        spaceBetween: 0,
        slidesPerView: '1',
        navigation: {
          nextEl: `.sell-swiper-list .button-next`,
          prevEl: `.sell-swiper-list .button-prev`,
        },
      });
    } else {
      let patentsSwiper = new Swiper('.sell-swiper-list', {
        slidesPerView: 'auto',
        spaceBetween: 20,
        slidesPerView: '2.4',
        navigation: {
          nextEl: `.sell-swiper-list .button-next`,
          prevEl: `.sell-swiper-list .button-prev`,
        },
      });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
